import React from "react";
import TooltipPortal from "../tooltip-portal";

const OnboardingRadio = ({
  label = "User Reference",
  onClick,
  options = defaultOptions,
  value,
  name,
  tooltipText = "",
}) => {
  return (
    <div className="radio-container">
      {label && <label htmlFor={name}>{label}</label>}
      <div>
        {options.map((option) => (
          <button
            onClick={(e) => {
              onClick(option.value);
            }}
            key={option.label}
            data-button-type={option.value === value ? "outline" : "text-white"}
            type="button"
          >
            <input
              id="metric-radio"
              type="radio"
              name={name}
              defaultChecked={option.defaultChecked}
              defaultValue={option.value}
            />
            <span>{option.label}</span>
          </button>
        ))}

        {tooltipText ? (
          <TooltipPortal id={name} body={tooltipText}>
            <span>?</span>
          </TooltipPortal>
        ) : (
          <span className="opacity-0 no-opacity" />
        )}
      </div>
    </div>
  );
};

export default OnboardingRadio;
